import {
  $getNations,
  $getProvinces,
  $getCities,
  $getLabels,
} from "@/utils/endpoints";
import { constants } from "@/utils/generic";

export const state = () => ({
  isMenuOpen: false,
  nations: [],
  provinces: [],
  cities: [],
  labels: {},
  appVersion: process.env.VUE_APP_VERSION || "0",
});

const getters = {
  isMenuOpen: (state) => state.isMenuOpen,
  nations: (state) => state.nations,
  provinces: (state) => state.provinces,
  cities: (state) => state.cities,
  labels: (state) => state.labels,
  appVersion: (state) => state.appVersion,
};

const mutations = {
  setMenuState: (state, newValue) => (state.isMenuOpen = newValue),
  setNations: (state, newValue) => (state.nations = newValue),
  setProvinces: (state, newValue) => (state.provinces = newValue),
  setCities: (state, newValue) => (state.cities = newValue),
  setLabels: (state, newValue) => (state.labels = newValue),
};
const namespaced = true;

const actions = {
  getNations: async ({ commit }) => {
    const value = await $getNations();
    const nations =
      (value && value.length && value.filter(({ eu }) => eu)) || value;
    commit("setNations", nations);
  },
  getProvinces: async ({ commit }) => {
    const provinces = await $getProvinces();
    commit("setProvinces", provinces);
  },
  getCities: async ({ commit }, token) => {
    const cities = await $getCities(token);
    commit("setCities", cities);
  },
  getLabels: async ({ commit }, lang = window.navigator.language) => {
    const labels =
      JSON.parse(sessionStorage.getItem(constants.LABELS_SK)) || (await $getLabels(lang));
    sessionStorage.setItem(constants.LABELS_SK, JSON.stringify(labels));
    actions.setLabels({ commit }, labels);
    return labels;
  },
  setLabels: async ({ commit }, labels) => {
    commit("setLabels", labels);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};
